import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontSize: '0.95rem', color: '#333' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>Privacy Policy</h1>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>1. Personal Data Collection</h2>
      <ul>
        <li>Name, email, phone number</li>
        <li>IP address</li>
        <li>Payment details</li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>2. Methods and Purpose of Data Collection</h2>
      <p>Data is collected via forms, cookies, and transactional processes to:</p>
      <ul>
        <li>Verify user identity and compliance.</li>
        <li>Facilitate communication and transaction processing.</li>
        <li>Enhance and improve our services.</li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>3. Data Storage, Security, and Retention</h2>
      <p>
        Personal data is stored securely using encryption and secure servers. Data is retained only as long as necessary to fulfill purposes
        described herein or comply with legal obligations.
      </p>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>4. Third-party Data Sharing</h2>
      <p>
        Personal data may be shared with trusted partners necessary for transaction processing and legal compliance. Mineralex Group ensures
        these partners comply with GDPR.
      </p>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>5. User Rights Regarding Personal Data</h2>
      <p>Under GDPR, users have the right to:</p>
      <ul>
        <li>Access and review personal data.</li>
        <li>Request corrections or updates.</li>
        <li>Request deletion or restriction of data processing.</li>
        <li>Object to processing based on legitimate interests.</li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>6. GDPR Compliance</h2>
      <p>
        Mineralex Group fully complies with GDPR, ensuring lawful, fair, transparent data processing.
      </p>

      <h2 style={{ fontWeight: 'bold', marginTop: '1.5rem' }}>7. Privacy-related Contact Information</h2>
      <p>
        For privacy-related inquiries, contact us at: <a href="mailto:privacy@mineralexgroup.com" className='text-blue-600'>privacy@mineralexgroup.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
